import { VStack } from "native-base";
import React from "react";

import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";

import ChangePasswordForm from "./components/Form";
import { ChangePassScreenProps } from "./types";

const ChangePasswordMobile = ({ isSubmiting, onCancel, onSubmit }: ChangePassScreenProps) => {
  return (
    <Container Header={<MobileHeader title="Alterar Senha" onBackPress={onCancel} />}>
      <VStack>
        <ChangePasswordForm isSubmiting={isSubmiting} onCancel={onCancel} onSubmit={onSubmit} />
      </VStack>
    </Container>
  );
};

export default ChangePasswordMobile;
